import React from 'react';
import CollapsibleText from '../CollapsibleText';
import { Tooltip } from 'antd';
import { IntlMessages } from '@/components';
import isEmpty from 'lodash/isEmpty';
import { ExclamationCircleOutlined } from '@ant-design/icons';

const UnpublishedChangesWarningTitle = ({ text, data }) => {
  return (
    <div>
      <CollapsibleText text={text} maxLength={200} />
      &nbsp;
      {data?.has_unpublished_changes && (
        <Tooltip
          placement="right"
          title={
            <>
              <IntlMessages id="ui-general-unpublished-tooltip-title" />
              {` ${!isEmpty(data.updated_fields) ? data.updated_fields?.join(', ') : '-'}`}
            </>
          }
        >
          &nbsp;
          <ExclamationCircleOutlined className="hp-text-color-warning-1" />
        </Tooltip>
      )}
    </div>
  );
};

export default UnpublishedChangesWarningTitle;
